export default __webpack_public_path__ + "static/media/impact-AE.1fe4f601.webp";